import usePermissions from "@hooks/usePermissions";
import { tr } from "date-fns/locale";
import { Navigate } from "react-router-dom";
import { Permissions } from "src/@types/permissions";

interface IPermissionBlockerProps {
  permissions: Permissions[];
  children: React.ReactNode;
  hideChildren?: boolean;
  allowed?: boolean;
}

export default function PermissionBlocker({
  permissions,
  children,
  hideChildren = false,
  allowed = true,
}: IPermissionBlockerProps) {
  const { permissionHandle } = usePermissions();

  if (!allowed || !permissionHandle(permissions)) {
    if(hideChildren){
      return null;
    }

    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
